import {noop} from '@benchling/js-utils';
import React from 'react';

import {PlateMapType} from 'samples/plate-maps/annotate-fill-plate-modal/AnnotateFillPlateModalConstants';
import {GenericPlateMapDisplayParams} from 'samples/plate-maps/PlateMapConstants';
import PlateMapPane from 'samples/plate-maps/PlateMapPane';

const EMPTY_WELL_INDICES: Set<number> = new Set();
const EMPTY_REFS: Array<React.RefObject<HTMLElement>> = [];

export const ViewOnlyPlateMapPane: React.FC<{
  plateMapDisplayParams: GenericPlateMapDisplayParams;
  header?: JSX.Element | null;
  maxPlateViewHeight?: string;
  className?: string;
  selectedWellIndices?: Set<number>;
}> = ({
  plateMapDisplayParams,
  header = null,
  maxPlateViewHeight = '500px',
  className,
  selectedWellIndices = EMPTY_WELL_INDICES,
}) => (
  <PlateMapPane
    header={header}
    plateMapDisplayParams={plateMapDisplayParams}
    isPlateMapViewOnly={true}
    showSelectionInViewOnly={true}
    selectedWellIndices={selectedWellIndices}
    setSelectedWellIndices={noop}
    previewedWellIndices={EMPTY_WELL_INDICES}
    deselectWellsOnClickRefs={EMPTY_REFS}
    maxPlateViewHeight={maxPlateViewHeight}
    className={className}
    showFinalMeasurements={true}
    plateMapType={PlateMapType.RECORD}
  />
);

export default ViewOnlyPlateMapPane;
